import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {CurrencyFormatter, ProductColumn, UnitFormatter, UpdatedByFormatter} from "../../../utils/formatters";
import {postData} from "../../../utils/request";
import React, {Fragment} from "react";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import ReturnGoodsForm from "./Elements/ReturnGoodsForm";
import Button from "../../form/Button";
import CheckBox from "../../form/CheckBox";
import {PriceView} from "../../classes/Price";
import connect from "react-redux/es/connect/connect";
import Modal from "../../layout/Modal";

const sortable = true;
const filterable = true;

class ReturnGoodsEditor extends React.Component {

    state = {
        filtered: false,
        componentEditor: "ReturnGoods",
        filter: [
            {column: "preset", value: "ReturnGoods"},
            {column: "saved", value: 1}
        ],
        labels: {seller: "Partner"},
        actionButtons: [],
        pool: {
            orderBy: {field: "displayname", direction: "ASC"},
            selection: [],
            pageSize: 5,
            pageSizes: [5,10,15,20,50],
            aggregations: {
                fields: {
                    "count": {
                        field: "pickedqty", type: "COUNT"
                    },
                    "pickedqty": {
                        field: "pickedqty", type: "SUM"
                    },
                }
            },
            component: "OperationProductPoolItem",
            view: ["id","product_id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"],
            columns: {
                "displayname": {
                    ...ProductColumn("component_id"),
                    width: 1,
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 1,
                    sortable,
                    filterable
                },
                "listprice_gross": {
                    header: 'Lista ár',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter
                },
                "stockqty": {
                    header: 'Raktárkészlet',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                "pickedqty": {
                    header: "Darabszám",
                    width: 1,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    sortable,
                    filterable,
                    aggregation: (value, row) => {
                        return <Fragment><span className="unit">Összesen: {UnitFormatter(row.pickedqty || 0, row.unit).props.children}</span><span className="unit">Tétel: {UnitFormatter(row.count || 0, row.unit).props.children}</span></Fragment>;
                    },
                    className: "unit",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="number" name="pickedqty" label={false} focus value={value}
                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
            }
        },
        returnGoodsAllModal: false
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
        };
        props.actionButtons = [
            <Button key="4" disabled={ props.isLoading || !props.values.id } color="primary" icon={{lib: "fa", name: "truck"}} className="pull-right" onClick={ async (e) => {
                const values = props.values;
                values.autocheckup = true;
                await props.processAction(async () => {
                    const response = await postData({
                        action: 'OperationList.doAction',
                        actionname: 'create',
                        data: await referenceActionData(values, this.props.componentConfig)
                    });
                    await this.props.pristineForm(false);
                    return response;
                });
            }}>
                Visszáru
            </Button>,
            <Fragment>
                <Modal
                    state={this.state.returnGoodsAllModal ? "on" : "off"}
                    theme="default"
                    size="small"
                    header="Biztos mehet?"
                    buttons={[
                        {
                            text: 'Mégse',
                            props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                            onClose: true,
                            onClick: async () => {
                                try {
                                    this.setState({returnGoodsAllModal: false});
                                } catch (e) {
                                }
                            }
                        },
                        {
                            text: 'Mehet',
                            props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                            onClick: async () => {
                                const values = props.values;
                                values.autocheckup = true;
                                await props.processAction(async () => {
                                    try {
                                        this.setState({returnGoodsAllModal: false});
                                    } catch (e) {
                                    }
                                    const response = await postData({
                                        action: 'OperationList.doAction',
                                        actionname: 'returnGoodsAll',
                                        data: await referenceActionData(values, this.props.componentConfig)
                                    });
                                    await this.props.pristineForm(false);
                                    return response;
                                });
                            }
                        }
                    ]}
                >
                </Modal>
                <Button key="5" disabled={ props.isLoading || !props.values.id } color="primary" icon={{lib: "fa", name: "truck"}} className="pull-right" onClick={ async (e) => {
                    try {
                        this.setState({returnGoodsAllModal: true});
                    } catch (e) {
                    }
                }}>
                    Teljes visszáru
                </Button>
            </Fragment>
        ];
        props.pool.parameters = {};
        props.pool.reqparams = {};
        if (props.values && props.values.source && props.values.seller) {
            props.pool.visible = true;
            props.pool.parameters.discount_type = "purchase";
            props.pool.parameters.partner = props.values.seller.partner_id;
            props.pool.parameters.store = props.values.source.id;
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.parameters.seller = props.values.seller.partner_id;
            props.pool.parameters.customer = props.values.customer.partner_id;
        } else {
            props.pool.visible = false;
        }
        props.filtered = this.state.filtered;
        if (this.state.filtered) {
            props.pool.filter = [{field: "stockqty", value: 0, operator: ">"},{field: "pickedqty", operator: "not isnull"}];
        } else {
            props.pool.filter = [{field: "stockqty", value: 0, operator: ">"}];
        }
        if (!this.props.till.pos.location && this.props.till.pos.store) {
            props.filter = [...props.filter, {field: "target", value: this.props.till.pos.store.id}];
            props.columns = {
                "label": {
                    header: 'Cimke',
                    width: 3,
                    sortable,
                    filterable,
                },
                "source.name": {
                    header: "Honnan",
                    width: 2,
                    sortable,
                    filterable,
                },
                "created_by": {
                    header: "Létrehozta",
                    width: 2,
                    renderer: UpdatedByFormatter
                },
                "created_at": {
                    header: "Létrehozás időpontja",
                    width: 2
                }
            }
        }
        props.pool.paginatorRight = <CheckBox onIcon={{lib: "fa", name: "box"}} offIcon={{lib: "fa", name: "box-open"}} value={this.state.filtered} label={false} saveChanges={(field, value) => {
            this.setState({filtered: !!value});
        }} />;
        return props;
    }

    renderer = (componentProps) => {
        return <ReturnGoodsForm {...componentProps} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} />;
    }

}

export default connect((state) => {
    return {
        till: state.app.till,
    }
})(createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: ReturnGoodsEditor,
    editor: "ReturnGoods",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "ReturnGoods";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
}));